module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-card"
  }, [_c('h2', {
    staticClass: "k6-green-text text-center",
    staticStyle: {
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.register.register")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('button', {
    staticClass: "google-login-btn",
    attrs: {
      "name": "GoogleSigninButton"
    },
    on: {
      "click": _vm.loginSsoGoogle
    }
  }, [_c('img', {
    staticClass: "google-icon",
    attrs: {
      "src": require("../../assets/google.png")
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("pages.login.google")) + "\n    ")])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.registerUser($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.email')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "",
      "autofocus": "",
      "required": ""
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": _vm.updateRegisterEmail
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "username"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.username')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "username",
      "name": "username",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": _vm.username
    },
    on: {
      "input": _vm.updateRegisterUsername
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": _vm.updateRegisterName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "surname"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.surname')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "surname",
      "name": "surname",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": _vm.surname
    },
    on: {
      "input": _vm.updateRegisterSurname
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "studentId"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.studentId')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "studentId",
      "name": "studentId",
      "placeholder": "",
      "pattern": "\\d{8}"
    },
    domProps: {
      "value": _vm.studentId
    },
    on: {
      "input": _vm.updateRegisterStudentId
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "password"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.password')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": _vm.password
    },
    on: {
      "input": _vm.updateRegisterPassword
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-12",
    attrs: {
      "for": "password2"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.passwordRetype')))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password2",
      "id": "password2",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": _vm.password2
    },
    on: {
      "input": _vm.updateRegisterPassword2
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('vue-recaptcha', {
    staticClass: "btn",
    attrs: {
      "sitekey": "6LeIxqYkAAAAAE3nZlQrt-ocv_GZ1YU-XffmNiXq"
    },
    on: {
      "verify": _vm.onVerify,
      "expired": _vm.onExpired
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "flex-direction": "column",
      "gap": "20px"
    }
  }, [_c('button', {
    staticClass: "k6-primary-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.register.register')))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("\n          " + _vm._s(_vm.$t("pages.register.alreadyHaveAnAccount")) + "\n          "), _c('a', {
    staticClass: "k6-green-text",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toLogin($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("pages.login.login")))])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-598f569c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-598f569c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/authentication/Register.vue
// module id = 1438
// module chunks = 1